<template>
  <md-table-row class="summary-row">
    <md-table-cell class="res-col-number">
      <div class="md-layout md-alignment-start-center">
        <md-field v-if="isEditing" class="inline-field field-reservation">
          <md-input
            :disabled="actionLoading"
            v-model="inlineEdit.reservation_number"
            type="text"
          ></md-input>
        </md-field>
        <template v-else>{{ item.reservation_number || "-" }}</template>
      </div>
    </md-table-cell>
    <md-table-cell class="res-col-confirmed">
      <div class="md-layout md-alignment-start-center">
        <md-switch
          v-if="isEditing"
          :disabled="actionLoading"
          v-model="inlineEdit.confirmed"
        />
        <span
          v-else
          class="status-pill"
          :class="item.confirmed ? 'is-confirmed' : 'is-unconfirmed'"
        >
          {{ item.confirmed ? "Yes" : "No" }}
        </span>
      </div>
    </md-table-cell>
    <md-table-cell class="res-col-date">
      <div class="md-layout md-alignment-start-center">
        <md-field v-if="isEditing" class="inline-field field-date">
          <md-input
            :disabled="actionLoading"
            v-model="inlineEdit.date"
            type="date"
          ></md-input>
        </md-field>
        <template v-else>{{ item.date | formatDate }}</template>
      </div>
    </md-table-cell>
    <md-table-cell class="res-col-night">
      <div class="md-layout md-alignment-start-center">
        {{ (isEditing ? inlineEdit.date : item.date) | getDayFromDate }}
      </div>
    </md-table-cell>
    <md-table-cell class="res-col-time">
      <div class="md-layout md-alignment-start-center">
        <md-field v-if="isEditing" class="inline-field field-time">
          <md-input
            :disabled="actionLoading"
            v-model="inlineEdit.time"
            type="time"
          ></md-input>
        </md-field>
        <template v-else>{{ item.time || "-" }}</template>
      </div>
    </md-table-cell>
    <md-table-cell class="res-col-actions col-actions actions-cell">
      <reservation-row-actions
        :is-editing="isEditing"
        :is-notes-expanded="isNotesExpanded"
        :has-notes="Boolean(item.notes)"
        :can-manage="Boolean(item.canManage)"
        :action-loading="actionLoading"
        @toggle-notes="$emit('toggle-notes')"
        @save="$emit('save')"
        @cancel="$emit('cancel')"
        @open-manifest="$emit('open-manifest')"
        @delete="$emit('delete')"
      />
    </md-table-cell>
  </md-table-row>
</template>

<script>
import ReservationRowActions from "./ReservationRowActions";

export default {
  name: "RestaurantReservationRow",
  components: { ReservationRowActions },
  props: {
    item: {
      type: Object,
      required: true
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    isNotesExpanded: {
      type: Boolean,
      default: false
    },
    inlineEdit: {
      type: Object,
      required: true
    },
    actionLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.actions-cell {
  text-align: right;
  white-space: nowrap;
}

::v-deep .actions-cell .md-table-cell-container {
  justify-content: flex-end;
}

.inline-field {
  margin: 0;
}

.status-pill {
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 0.75rem;
  min-width: 44px;
  padding: 2px 8px;
  text-align: center;
}

.status-pill.is-confirmed {
  background: #4caf50;
}

.status-pill.is-unconfirmed {
  background: #9e9e9e;
}
</style>
